module.exports = __webpack_public_path__ + "img/poster_a00.cfffb7a7.jpg";